import React from 'react';
import { Route } from 'react-router-dom';
import BlogCategoriesList from '../pages/blog/BlogCategoriesList';
import CreateBlogCategory from '../pages/blog/CreateBlogCategory';
import EditBlogCategory from '../pages/blog/EditBlogCategory';
import ProtectedRoute from '../components/global/ProtectedRoute';

const blogCategoriesRoutes = (
    <>
        <Route
            path="/blog/categories"
            element={
                <ProtectedRoute requiredPermission="blog-categories.view">
                    <BlogCategoriesList />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/categories/create"
            element={
                <ProtectedRoute requiredPermission="blog-categories.create">
                    <CreateBlogCategory />
                </ProtectedRoute>
            }
        />
        <Route
            path="/blog/categories/:id/edit"
            element={
                <ProtectedRoute requiredPermission="blog-categories.update">
                    <EditBlogCategory />
                </ProtectedRoute>
            }
        />
    </>
);

export default blogCategoriesRoutes;
